import { cn } from '@utils/helpers';
import { ChevronDownIcon } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';
import { PublicationDocumentItem } from './PublicationDocumentItem';
import type { PublicationsMonthGroupProps } from './types';

export const PublicationsMonthGroup: React.FC<PublicationsMonthGroupProps> = ({ documents, month, isFirst, language, variousFundsText }) => {
  const [isVisible, setIsVisible] = useState(isFirst);

  useEffect(() => {
    if (isFirst) {
      setIsVisible(true);
    }
  }, [isFirst]);

  const toggleVisibility = useCallback((): void => {
    setIsVisible((prev) => !prev);
  }, []);

  return (
    <div className="pb-5 pl-10 max-[600px]:pl-2.5">
      <h5
        onClick={toggleVisibility}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleVisibility();
          }
        }}
        className="cursor-pointer pb-5 text-lg text-gray-500 flex gap-6 items-center"
      >
        <span className="inline-block min-w-[75px]">{month}</span>
        <ChevronDownIcon className={cn('size-4 text-gray-500', isVisible && 'rotate-180')} />
      </h5>
      <div className="border-b border-[#ececec]">
        <div className={`grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out ${isVisible ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
          <div className="overflow-hidden">
            <div className="pl-[100px] max-[600px]:pl-2.5">
              {documents.map((document, index) => (
                <PublicationDocumentItem key={document.id ?? index} document={document} language={language} variousFundsText={variousFundsText} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
